/** Number of jokers to place on the board when using the jokerPreBooster */
import { ILimit } from 'Utility/MathHelper';
import Point from 'Utility/Point';

export const JOKER_PRE_BOOSTER_COUNT = 3;
/** Distance from top of stack that the pre booster joker card can be added */
export const JOKER_PRE_BOOSTER_IN_STACK_PLACEMENT_RANGE: ILimit = {
    max: 15,
    min: 4,
};

/** Defines the offset of the joker pre booster when in-play */
export const JOKER_PRE_BOOSTER_IN_PLAY_OFFSET: Point = new Point(0, -20);

/** Distance from top of stack that the pre booster canister card can be added */
export const CANISTER_PRE_BOOSTER_IN_STACK_PLACEMENT_RANGE: ILimit = {
    max: 15,
    min: 6,
};
